module.exports = __webpack_public_path__ + "img/career-value.c9b8b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/career-value.png
// module id = 1689
// module chunks = 1